import React, { useEffect, useState } from 'react';
import { CalendarCheck, ChevronDown, ChevronRight } from 'lucide-react';
import { partitionRosterServices } from './rosterUtils';
import RosterServiceRow from './RosterServiceRow';

const EmptyRoster = () => (
  <div className="border border-dashed border-slate-200 px-5 py-10 text-center">
    <CalendarCheck className="mx-auto h-8 w-8 text-slate-300" />
    <p className="mt-3 font-medium text-slate-800">Geen diensten deze maand</p>
    <p className="mt-1 text-sm text-slate-500">Voor deze maand zijn nog geen diensten gepland.</p>
  </div>
);

const RosterServiceList = ({ services = [], year, month, onOpen, now = new Date() }) => {
  const { mode, upcoming, historical } = partitionRosterServices(services, { year, month, now });
  const [historyOpen, setHistoryOpen] = useState(upcoming.length === 0);

  useEffect(() => {
    setHistoryOpen(upcoming.length === 0);
  }, [year, month, upcoming.length]);

  if (!services.length) return <EmptyRoster />;

  const historicalTitle = mode === 'current' ? 'Eerder deze maand' : 'Historie';

  return (
    <div className="overflow-hidden border border-slate-200 bg-white" aria-label="Diensten">
      {upcoming.length > 0 && (
        <section aria-labelledby="roster-upcoming-heading">
          <div className="border-b border-slate-200 bg-slate-50/70 px-4 py-3 sm:px-5">
            <h3 id="roster-upcoming-heading" className="text-sm font-semibold text-slate-900">Aankomend <span className="ml-1 font-normal text-slate-500">{upcoming.length}</span></h3>
          </div>
          {upcoming.map((service) => <RosterServiceRow key={service.id} service={service} onOpen={onOpen} />)}
        </section>
      )}

      {historical.length > 0 && (
        <section aria-labelledby="roster-history-heading">
          <button
            type="button"
            onClick={() => setHistoryOpen((open) => !open)}
            aria-expanded={historyOpen}
            aria-controls="roster-history-list"
            className="flex min-h-11 w-full items-center justify-between border-t border-slate-200 bg-slate-50/50 px-4 py-3 text-left hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-teal-500 sm:px-5"
          >
            <span>
              <span id="roster-history-heading" className="text-sm font-semibold text-slate-700">{historicalTitle}</span>
              <span className="ml-2 text-sm text-slate-500">{historical.length} {historical.length === 1 ? 'dienst' : 'diensten'}</span>
            </span>
            {historyOpen ? <ChevronDown className="h-4 w-4 text-slate-500" /> : <ChevronRight className="h-4 w-4 text-slate-500" />}
          </button>
          {historyOpen && (
            <div id="roster-history-list">
              {historical.map((service) => <RosterServiceRow key={service.id} service={service} historical onOpen={onOpen} />)}
            </div>
          )}
        </section>
      )}
    </div>
  );
};

export default RosterServiceList;

